import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Icon } from 'components/Icon'
import { TableNotFoundHint } from 'components/TableNotFoundHint'

import * as S from './styled'

export type CertificationTableProps = {
  rows: any
  isLoading?: boolean
}

export function IndustryCertificateTable({
  rows,
  isLoading
}: CertificationTableProps) {
  const { t } = useTranslation()

  const loadingTable = () => {
    if (!rows.length && isLoading) {
      return (
        <S.TableLoadingFistTime>
          {t('common:loadingData')}
        </S.TableLoadingFistTime>
      )
    }
    if (rows.length && isLoading) {
      return <S.TableLoading>{t('common:loadingData')}</S.TableLoading>
    }

    if (!rows.length && !isLoading) {
      return <TableNotFoundHint />
    }
  }

  return (
    <S.Wrapper data-testid="IndustryTable">
      <S.Teste>
        <S.ScrollWrapper>
          <S.Table id="table-fixed">
            <tbody>
              <S.Line id="header">
                <S.Header>{t('tables:socialReason')}</S.Header>
                <S.Header>{t('tables:CNPJ')}</S.Header>
                <S.Header>{t('tables:sif')}</S.Header>
                <S.Header className="right">{t('tables:city')}</S.Header>
                <S.Header className="right">{t('tables:uf')}</S.Header>
              </S.Line>
              {rows &&
                rows.map(each => (
                  <S.Line id="values" key={each.id}>
                    <S.Column>{each.name}</S.Column>
                    <S.Column>{each.cnpj}</S.Column>
                    <S.Column>{each.inspectionNum}</S.Column>
                    <S.Column className="right">{each.city}</S.Column>
                    <S.Column className="right">{each.state}</S.Column>
                  </S.Line>
                ))}
            </tbody>
          </S.Table>
        </S.ScrollWrapper>
        <S.Table id="table-fixed">
          <tbody>
            <S.Line id="header">
              <S.Header>{t('common:details')}</S.Header>
            </S.Line>
            {Boolean(rows && rows.length) &&
              rows.map((row, index) => (
                <S.Line key={index}>
                  <S.Column id="actions-column">
                    <Link to={`/certificacoes/detalhes/${row.id}`}>
                      <S.Link>
                        <Icon icon="input-visible" height={16} width={16} />
                      </S.Link>
                    </Link>
                  </S.Column>
                </S.Line>
              ))}
          </tbody>
        </S.Table>
      </S.Teste>

      {loadingTable()}
    </S.Wrapper>
  )
}
